import React, {FunctionComponent, ReactElement, useState} from 'react';
import {Button, Container, IconButton} from '@material-ui/core';
import {NavMenuItemData} from '@treez-ui/core/header/NavMenuItem';
import styled from 'styled-components';
import {NavigationMenu} from './NavigationMenu';
import UserMenu from './UserMenu';
import {usePingAuthContext} from '../../../lib/auth/ping/PingAuthProvider';
import {PingAuthStatus} from '../../../lib/auth/ping/types/PingAuthStatus';
import TreezLogo from '../../icons/TZ_logo.svg';
import CloseIcon from '../../icons/Close.svg';
import MenuIcon from '../../icons/Menu.svg';

const HeaderContainer = styled(Container)`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

interface HeaderGroupProps {
    separators?: boolean;
}

const HeaderGroup = styled.div<HeaderGroupProps>`
    display: flex;
    align-items: center;
    ${(props) =>
        props.separators &&
        `
    > div {
        border-left: 1px solid #60B336;
    }
    `}
`;

// Use contextState to Control the state of the Entity Picker as the consumer
// Instead pass in useOneTreezEntityPicker = true to use the OneTreez navigation functionality is as

interface Props {
    children?: ReactElement;
    logoUrl?: string;
    menuItems?: NavMenuItemData[];
    menuItemsDash?: NavMenuItemData[];
    onLogoClick: () => void;
}

const DEFAULT_LOGO_URL = TreezLogo;

export const Header: FunctionComponent<Props> = (props: Props) => {
    const {logoUrl, menuItems, menuItemsDash, onLogoClick} = props;

    const [menuOpen, setMenuOpen] = useState<boolean>(false);

    const {status, user, logIn, logOut} = usePingAuthContext();

    return (
        <div className="treez-header">
            <div className="fixed-header">
                {menuItems && (
                    <NavigationMenu
                        menuItems={menuItems}
                        menuItemsDash={menuItemsDash}
                        onClose={() => setMenuOpen(false)}
                        open={menuOpen}
                    />
                )}
                <HeaderContainer maxWidth={false}>
                    <HeaderGroup>
                        {menuItems && !menuOpen && (
                            <IconButton
                                className="menu-icon-button"
                                onClick={() => setMenuOpen(true)}
                            >
                                <img src={MenuIcon} />
                            </IconButton>
                        )}
                        {menuItems && menuOpen && (
                            <IconButton
                                className="menu-icon-button"
                                onClick={() => setMenuOpen(false)}
                            >
                                <img src={CloseIcon} />
                            </IconButton>
                        )}
                        <img
                            className="logo-image"
                            src={logoUrl || DEFAULT_LOGO_URL}
                            onClick={() => onLogoClick()}
                        />
                    </HeaderGroup>
                    <HeaderGroup>
                        {status === PingAuthStatus.LOGGED_IN && user != null ? (
                            <UserMenu user={user} onLogout={logOut} />
                        ) : (
                            <Button onClick={logIn} className="sign-in-button">
                                Sign In
                            </Button>
                        )}
                    </HeaderGroup>
                </HeaderContainer>
            </div>
            <div className="spacer">{/* pushes content below fixed header bar */}</div>
        </div>
    );
};
